module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-bc5f15f4!./packages/dof-simple-flow/colmo.css
// module id = 532
// module chunks = 0 1